import { ONE_MONTH_IN_SECONDS, ONE_WEEK_IN_SECONDS } from "../constants/time"

export const STAKING_LOCK_DURATION = {
  ONE_WEEK: ONE_WEEK_IN_SECONDS,
  TWO_WEEKS: ONE_WEEK_IN_SECONDS * 2,
  ONE_MONTH: ONE_MONTH_IN_SECONDS,
  FOUR_MONTHS: ONE_MONTH_IN_SECONDS * 4,
} as const

export type StakingLockDurationType =
  (typeof STAKING_LOCK_DURATION)[keyof typeof STAKING_LOCK_DURATION]

export type Stake = {
  /**
   * Unique identifier of the VeBTC NFT token.
   */
  id: string

  /**
   * Staked amount.
   */
  amount: bigint

  /**
   * Unlock date as a timestamp.
   */
  unlockTimestamp: number

  /**
   * Balance of the unique VeBTC NFT token. See `tokenId` field.
   */
  votingPower: bigint | undefined

  /**
   * Timestamp of the stake creation.
   */
  createdAt: number

  /**
   * Number of seconds to lock tokens for.
   */
  lockDuration: number

  /**
   * Determines whether the stake is locked permanently or not.
   */
  isPermanent: boolean

  /**
   * Determines whether the stake is withdrawable or not.
   */
  canBeUnlocked: boolean
}

// TODO: Temporary type
export type PastStakeActivity = {
  withdrawDate: string
  matsAmount: string
} & Omit<Stake, "lockDuration" | "unlockTimestamp" | "createdAt">
